/* This file is auto-generated with figma-svg. */
import hoc from '@hh.ru/magritte-ui-icon/hoc';
import { ATSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ATSize16';
import { ATSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ATSize24';
import { ATSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ATSize32';
import { AUSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AUSize16';
import { AUSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AUSize24';
import { AUSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AUSize32';
import { AZSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AZSize16';
import { AZSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AZSize24';
import { AZSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/AZSize32';
import { BYSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/BYSize16';
import { BYSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/BYSize24';
import { BYSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/BYSize32';
import { ENSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ENSize16';
import { ENSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ENSize24';
import { ENSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/ENSize32';
import { GESize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/GESize16';
import { GESize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/GESize24';
import { GESize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/GESize32';
import { KGSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KGSize16';
import { KGSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KGSize24';
import { KGSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KGSize32';
import { KZSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KZSize16';
import { KZSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KZSize24';
import { KZSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/KZSize32';
import { RUSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/RUSize16';
import { RUSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/RUSize24';
import { RUSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/RUSize32';
import { UZSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/country/UZSize16';
import { UZSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/country/UZSize24';
import { UZSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/country/UZSize32';

export const KZSize32 = /* #__PURE__*/ hoc<'KZSize32'>(KZSize32Glyph, 'KZSize32');
export const KZSize24 = /* #__PURE__*/ hoc<'KZSize24'>(KZSize24Glyph, 'KZSize24');
export const ENSize32 = /* #__PURE__*/ hoc<'ENSize32'>(ENSize32Glyph, 'ENSize32');
export const GESize24 = /* #__PURE__*/ hoc<'GESize24'>(GESize24Glyph, 'GESize24');
export const ATSize32 = /* #__PURE__*/ hoc<'ATSize32'>(ATSize32Glyph, 'ATSize32');
export const ATSize24 = /* #__PURE__*/ hoc<'ATSize24'>(ATSize24Glyph, 'ATSize24');
export const ATSize16 = /* #__PURE__*/ hoc<'ATSize16'>(ATSize16Glyph, 'ATSize16');
export const ENSize16 = /* #__PURE__*/ hoc<'ENSize16'>(ENSize16Glyph, 'ENSize16');
export const ENSize24 = /* #__PURE__*/ hoc<'ENSize24'>(ENSize24Glyph, 'ENSize24');
export const KGSize32 = /* #__PURE__*/ hoc<'KGSize32'>(KGSize32Glyph, 'KGSize32');
export const KGSize16 = /* #__PURE__*/ hoc<'KGSize16'>(KGSize16Glyph, 'KGSize16');
export const KGSize24 = /* #__PURE__*/ hoc<'KGSize24'>(KGSize24Glyph, 'KGSize24');
export const GESize16 = /* #__PURE__*/ hoc<'GESize16'>(GESize16Glyph, 'GESize16');
export const AUSize24 = /* #__PURE__*/ hoc<'AUSize24'>(AUSize24Glyph, 'AUSize24');
export const BYSize16 = /* #__PURE__*/ hoc<'BYSize16'>(BYSize16Glyph, 'BYSize16');
export const KZSize16 = /* #__PURE__*/ hoc<'KZSize16'>(KZSize16Glyph, 'KZSize16');
export const RUSize32 = /* #__PURE__*/ hoc<'RUSize32'>(RUSize32Glyph, 'RUSize32');
export const BYSize32 = /* #__PURE__*/ hoc<'BYSize32'>(BYSize32Glyph, 'BYSize32');
export const AZSize16 = /* #__PURE__*/ hoc<'AZSize16'>(AZSize16Glyph, 'AZSize16');
export const RUSize16 = /* #__PURE__*/ hoc<'RUSize16'>(RUSize16Glyph, 'RUSize16');
export const AUSize32 = /* #__PURE__*/ hoc<'AUSize32'>(AUSize32Glyph, 'AUSize32');
export const BYSize24 = /* #__PURE__*/ hoc<'BYSize24'>(BYSize24Glyph, 'BYSize24');
export const GESize32 = /* #__PURE__*/ hoc<'GESize32'>(GESize32Glyph, 'GESize32');
export const AZSize24 = /* #__PURE__*/ hoc<'AZSize24'>(AZSize24Glyph, 'AZSize24');
export const AUSize16 = /* #__PURE__*/ hoc<'AUSize16'>(AUSize16Glyph, 'AUSize16');
export const RUSize24 = /* #__PURE__*/ hoc<'RUSize24'>(RUSize24Glyph, 'RUSize24');
export const AZSize32 = /* #__PURE__*/ hoc<'AZSize32'>(AZSize32Glyph, 'AZSize32');
export const UZSize32 = /* #__PURE__*/ hoc<'UZSize32'>(UZSize32Glyph, 'UZSize32');
export const UZSize24 = /* #__PURE__*/ hoc<'UZSize24'>(UZSize24Glyph, 'UZSize24');
export const UZSize16 = /* #__PURE__*/ hoc<'UZSize16'>(UZSize16Glyph, 'UZSize16');
